import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ActiveBulkUploadJob,
  BulkUploadJobTrackerService,
} from 'src/app/pages/stock/services/bulk-upload-job-tracker.service';

@Component({
  selector: 'app-bulk-upload-status-indicator',
  templateUrl: './bulk-upload-status-indicator.component.html',
  styleUrls: ['./bulk-upload-status-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadStatusIndicatorComponent {
  readonly jobs$: Observable<ReadonlyArray<ActiveBulkUploadJob>> = this.tracker.activeJobs$;

  constructor(private readonly tracker: BulkUploadJobTrackerService) {}

  trackByJobId = (_index: number, job: ActiveBulkUploadJob): string => job.jobId;

  onDismiss(jobId: string): void {
    this.tracker.dismissJob(jobId);
  }

  onViewResults(jobId: string): void {
    this.tracker.openResultsFor(jobId);
  }
}
